import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@material-ui/core';
import TemplateIconUrl from '../../../../../assets/img/TemplateIcon.svg';
import SelectedTemplateIconUrl from '../../../../../assets/img/SelectedTemplateIcon.svg';
import { getEmailTemplateTypes } from '../../../../../utils/cmsUtils';

export default function TemplateRightPanel({
  selectedId,
  onPick,
  onClose,
  listType = 'templateTypes',
}) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await getEmailTemplateTypes(listType);
        const items = res?.data?.listEmailTemplateVariables || [];
        if (!cancelled) {
          const mapped = items
            .map((it, idx) => {
              if (!it) return null;
              const id = it.id ?? it.keyword ?? `tpl_${idx}`;
              const label = it.label ?? it.keyword ?? it.type ?? `Template ${idx + 1}`;
              const templateType = it.keyword ?? it.type ?? label;
              return { ...it, id, label, templateType };
            })
            .filter(Boolean);
          setTemplates(mapped);
        }
      } catch (e) {
        if (!cancelled) setTemplates([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [listType]);

  return (
    <div className='component-container' style={{ width: 300 }}>
      <div className='email-editor-header'>
        <h5 className='edit-email-edit-text p-3 m-2'>Choose a template</h5>
        <IconButton
          className='close-icon'
          style={{ color: 'white', marginRight: 8 }}
          onClick={onClose}
          aria-label='Close'
        >
          <CloseIcon style={{ color: 'white' }} />
        </IconButton>
      </div>

      <div
        className='email-editor-panel'
        style={{
          padding: 12,
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 16,
          alignItems: 'stretch',
          overflow: 'scroll',
          scrollbarWidth: 'none',
          height: '530px',
        }}
      >
        {loading ? (
          <div style={{ gridColumn: '1 / -1', padding: 12, color: '#9aa3a7' }}>Loading…</div>
        ) : (
          templates.map((t) => {
            const active = selectedId === t.id;
            return (
              <div
                key={t.id}
                role='button'
                tabIndex={0}
                onClick={() => onPick(t)}
                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onPick(t)}
                aria-pressed={active}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    border: `1px solid ${active ? '#29E67C' : '#69707B'}`,
                    borderRadius: 12,
                    padding: 12,
                    background: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 106,
                    width: '100%',
                  }}
                >
                  <img
                    src={active ? SelectedTemplateIconUrl : TemplateIconUrl}
                    alt=''
                    width={48}
                    height={48}
                    style={{
                      display: 'block',
                      ...(active ? {} : { opacity: 0.9 }),
                    }}
                  />
                </div>
                <div
                  style={{
                    fontSize: 14,
                    textAlign: 'center',
                    marginTop: 8,
                    color: active ? '#29E67C' : '#6F7781',
                    fontWeight: 400,
                  }}
                >
                  {t.label}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
